<app-breadcrumb [master]="'Administracja'" [parentName]="'Regionalni'" [name]="'Szczegóły'"></app-breadcrumb>
<mat-tab-group >
  <mat-tab label="Dane">
    <app-regional-details-view *ngIf="!modify" [regional]="regional" (modifyClicked)="modify = true" ></app-regional-details-view>
    <app-regional-add *ngIf="modify" [regional]="regional" (closeModification)="modify = false; loadRegional()"></app-regional-add>

  </mat-tab>
  <mat-tab label="Historia zmian">
    <ng-template matTabContent>
      <app-log-list  [regional]="regional"></app-log-list>
    </ng-template>
  </mat-tab>
</mat-tab-group>
